import React from 'react';
import LoadingOverlay from 'Components/UI/LoadingOverlay/LoadingOverlay';
import Dock from 'Components/UI/Dock';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { useLayoutContext } from 'Context/LayoutContext';
import Viewport from './Viewport';

function MainContent() {
  const { householdLoading } = useSimpleHousehold();
  const { setNavigationVisible } = useLayoutContext();

  // Turn on navigation for all legacy pages
  React.useEffect(() => {
    setNavigationVisible(true);
  }, []);

  return (
    <>
      <Viewport />
      <Dock />
      {householdLoading && <LoadingOverlay />}
    </>
  );
}

export default MainContent;
